/**
 * Subscription Access Hook
 * Custom hook to check subscription access and status
 */

import { useCurrentShop } from '../store/auth';
import { getSubscriptionStatus, SubscriptionStatus } from '../utils/subscriptionUtils';

export interface SubscriptionAccess {
  hasAccess: boolean;
  subscriptionStatus: SubscriptionStatus;
  isLoading: boolean;
}

/**
 * Hook to check if user has active subscription access
 * Returns false if no active plan or subscription expired
 */
export const useSubscriptionAccess = (): SubscriptionAccess => {
  const shop = useCurrentShop();

  if (!shop) {
    return {
      hasAccess: false,
      subscriptionStatus: {
        hasActivePlan: false,
        planName: null,
        expiryDate: null,
        daysRemaining: 0,
        isExpired: true,
        isExpiringSoon: false,
      },
      isLoading: true,
    };
  }

  const subscriptionStatus = getSubscriptionStatus(shop.subscriptions);

  return {
    hasAccess: subscriptionStatus.hasActivePlan,
    subscriptionStatus,
    isLoading: false,
  };
};
